import React from "react";
import {useTranslation} from "react-i18next";
import {SzButton, SzIcon} from "@suezenv/react-theme-components";
import './acknowledgeAlarm.scss'

const AcknowledgeAlarm: any = (props: any) => {
    const {t} = useTranslation();
    const {user, acknowledgeAlarmConfirmHandler, closeHandle} = props;

    return (
        <>
            <div className="row m-0 p-0 mb-2">
                <div className="col-1">
                    <SzIcon variant="line" icon="alarm-bell"/>
                </div>
                <div className="col-11">
                    <p>{t("alarm:acknowledge_alarms_confirmation")}</p>
                </div>
            </div>
            <div className="row m-0 p-0 mb-2">
                <div className="col-1"></div>
                <div className="col-11 confirmation-btns">
                    <SzButton 
                        onClick={() => {
                            acknowledgeAlarmConfirmHandler(user);
                            closeHandle();
                        }} 
                        className="mr-3"
                        variant='outlined'
                    >
                        {t("common:btn.confirm")}
                    </SzButton>
                    <SzButton 
                        onClick={() => {
                            closeHandle();
                        }} 
                        className="mr-3"
                    >
                        {t("common:btn.cancel")}
                        
                    </SzButton>
                </div>
            </div>
        </>
    );
};

export default AcknowledgeAlarm;
